import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import InfoSection from '../components/InfoSection';
import {
  homeObjOne,
  homeObjTwo,
  homeObjThree
} from '../components/InfoSection/Data';
// import { Helmet } from "react-helmet";
// TODO: reimplement react helmet, use example in Tumble Delivery Website

function Home() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
        <Sidebar isopen={isOpen} toggle={toggle} />
        <Navbar toggle={toggle} darkMode={false} />
        <HeroSection />
        {/* <InfoSection {...homeObjOne} />
        <InfoSection {...homeObjTwo} />
        <InfoSection {...homeObjThree} /> */}
        <Footer />
    </>
  );
}

export default Home;